const focusToTopErrorFieldOnScreen = () => {
  if (typeof window !== "undefined") {
    focusToTopErrorFieldOf(window.document);
  }
};
const focusToTopErrorFieldOf = (container) => {
  const topErrorField = container.querySelector(
    'input[aria-invalid="true"], select[aria-invalid="true"], button[aria-invalid="true"]'
  );
  topErrorField?.focus();
};
export {
  focusToTopErrorFieldOf,
  focusToTopErrorFieldOnScreen
};
//# sourceMappingURL=focus-to-top-error-field.js.map
